// @ts-nocheck
import { Close, MenuOutlined } from "@mui/icons-material";
import { Box, IconButton, Stack, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import routes from "../../routes/navRoutes";
import Logo from "../Logo/Logo";
import AccountButton from "./Footer/SidenavAccountButton";
import LogoutButton from "./Footer/SidenavLogoutButton";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import SidenavNetworks from "./Footer/SidenavNetworks";
import SidenavDrawer from "./SidenavDrawer";
import SidenavItem from "./SidenavItem";
import { useAuth } from "../../providers/AuthProvider";
import { PlaceChip } from "../Inputs/Chips/PlaceChip";
import { isAdmin } from "../../utils/helpers";
import LaunchCampaignReminder from "../Reminders/LaunchCampaignReminder";

export default function Sidenav() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const isMobile = useMediaQuery("(max-width:600px)");
  const [open, setOpen] = useState<boolean>(false);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <>
      <SidenavDrawer open={open}>
        <Stack alignItems={"space-between"} height={"100%"} p={2}>
          {/* SIDENAV HEADER */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ bgcolor: "white", p: 1 }}
          >
            <IconButton
              edge="start"
              aria-label="Close menu"
              onClick={toggleDrawer}
              sx={{
                display: { xs: "block", sm: "none" },
              }}
            >
              <Close />
            </IconButton>
            {isMobile && (
              <img
                src="/assets/navbar/star.png"
                style={{ position: "fixed", top: "-106px", left: "-159px", pointerEvents: "none" }}
              />
            )}
            <Logo />
          </Stack>

          <PlaceChip mt={1} mb={2} />

          {/* SIDENAV BODY */}
          <Stack sx={{ boxSizing: "border-box" }} gap={0.5}>
            {routes.map((route, index) => {
              if (!isAdmin(user) && route?.hide?.(user)) return null;
              const active =
                pathname === route.path || (pathname.startsWith(route.path) && route.path !== "/");
              return (
                <SidenavItem
                  key={index}
                  route={route}
                  active={active}
                  handleToggle={toggleDrawer}
                />
              );
            })}
          </Stack>

          <Box sx={{ flexGrow: 1 }} />

          <LaunchCampaignReminder />

          {/* SIDENAV FOOTER */}
          <Stack mb={2}>
            <AccountButton handleToggle={toggleDrawer} />
            <LogoutButton />
            <Box mt={1} display="flex" justifyContent="flex-start">
              <LanguageSelector align="left" />
            </Box>
          </Stack>
          {/* NETWORKS IF MOBILE */}
          {isMobile && <SidenavNetworks />}
        </Stack>
      </SidenavDrawer>

      <IconButton
        edge="start"
        aria-label="Open menu"
        onClick={toggleDrawer}
        sx={{
          display: { xs: "block", md: "none" },
          position: "absolute",
          top: "0.8rem",
          left: "0.8rem",
        }}
      >
        <MenuOutlined />
      </IconButton>
    </>
  );
}
